import { CSV_FILE_EXTENSION, CSV_UPLOAD_MIME_TYPES } from './LabelValuesSection.constants';

export const isAcceptableCsvUploadFile = (file: File): boolean => {
	if (file.name.toLowerCase().endsWith(CSV_FILE_EXTENSION)) {
		return true;
	}
	const mime = file.type.toLowerCase();
	return mime !== '' && CSV_UPLOAD_MIME_TYPES.has(mime);
};
